// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Operation;
(function (Operation) {
    Operation["OPERATION_UNSPECIFIED"] = "OPERATION_UNSPECIFIED";
    Operation["CREATE"] = "CREATE";
    Operation["LIST"] = "LIST";
    Operation["UPDATE"] = "UPDATE";
    Operation["DELETE"] = "DELETE";
    Operation["SEARCH"] = "SEARCH";
})(Operation || (Operation = {}));
export var Operation_index;
(function (Operation_index) {
    Operation_index[Operation_index["OPERATION_UNSPECIFIED"] = 0] = "OPERATION_UNSPECIFIED";
    Operation_index[Operation_index["CREATE"] = 1] = "CREATE";
    Operation_index[Operation_index["LIST"] = 2] = "LIST";
    Operation_index[Operation_index["UPDATE"] = 3] = "UPDATE";
    Operation_index[Operation_index["DELETE"] = 4] = "DELETE";
    Operation_index[Operation_index["SEARCH"] = 5] = "SEARCH";
})(Operation_index || (Operation_index = {}));
export var DataType;
(function (DataType) {
    DataType["DATA_TYPE_UNSPECIFIED"] = "DATA_TYPE_UNSPECIFIED";
    DataType["PERSON"] = "PERSON";
    DataType["APPOINTMENT"] = "APPOINTMENT";
    DataType["APPOINTMENT_STATUS"] = "APPOINTMENT_STATUS";
    DataType["APPOINTMENT_TYPE"] = "APPOINTMENT_TYPE";
    DataType["APPOINTMENT_CONFIRMATION"] = "APPOINTMENT_CONFIRMATION";
    DataType["SAVE_THE_DATE"] = "SAVE_THE_DATE";
    DataType["INSURANCE"] = "INSURANCE";
    DataType["AGING"] = "AGING";
    DataType["PHOTO"] = "PHOTO";
    DataType["ACCOUNT"] = "ACCOUNT";
    DataType["PROVIDER"] = "PROVIDER";
    DataType["OPERATORY"] = "OPERATORY";
    DataType["CLIENT_LOCATION"] = "CLIENT_LOCATION";
    DataType["RECALL"] = "RECALL";
    DataType["FRAMES_ORDER"] = "FRAMES_ORDER";
    DataType["CONTACTS_ORDER"] = "CONTACTS_ORDER";
    DataType["VACCINE_RECALL"] = "VACCINE_RECALL";
    DataType["CONTACT_INFO"] = "CONTACT_INFO";
    DataType["PET"] = "PET";
    DataType["PERSON_SERVICEABLE"] = "PERSON_SERVICEABLE";
    DataType["RECALL_TYPE"] = "RECALL_TYPE";
    DataType["MEDICAL_HISTORY"] = "MEDICAL_HISTORY";
    DataType["PROCEDURE_LOG"] = "PROCEDURE_LOG";
    DataType["APPOINTMENT_PROCEDURE"] = "APPOINTMENT_PROCEDURE";
    DataType["APPOINTMENT_PROVIDER"] = "APPOINTMENT_PROVIDER";
    DataType["PROCEDURE_CODE"] = "PROCEDURE_CODE";
    DataType["FEE_SCHEDULE"] = "FEE_SCHEDULE";
    DataType["FEE_SCHEDULE_FEE"] = "FEE_SCHEDULE_FEE";
    DataType["DOCUMENT"] = "DOCUMENT";
    DataType["MEDICAL_CONDITION"] = "MEDICAL_CONDITION";
    DataType["TEXT_NOTE"] = "TEXT_NOTE";
    DataType["PAYMENT"] = "PAYMENT";
    DataType["INSURANCE_PLAN"] = "INSURANCE_PLAN";
    DataType["INSURANCE_PAYER_DETAILS"] = "INSURANCE_PAYER_DETAILS";
    DataType["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
    DataType["SCHEDULE_AVAILABILITY"] = "SCHEDULE_AVAILABILITY";
    DataType["SCHEDULE"] = "SCHEDULE";
})(DataType || (DataType = {}));
export var DataType_index;
(function (DataType_index) {
    DataType_index[DataType_index["DATA_TYPE_UNSPECIFIED"] = 0] = "DATA_TYPE_UNSPECIFIED";
    DataType_index[DataType_index["PERSON"] = 1] = "PERSON";
    DataType_index[DataType_index["APPOINTMENT"] = 2] = "APPOINTMENT";
    DataType_index[DataType_index["APPOINTMENT_STATUS"] = 3] = "APPOINTMENT_STATUS";
    DataType_index[DataType_index["APPOINTMENT_TYPE"] = 4] = "APPOINTMENT_TYPE";
    DataType_index[DataType_index["APPOINTMENT_CONFIRMATION"] = 5] = "APPOINTMENT_CONFIRMATION";
    DataType_index[DataType_index["SAVE_THE_DATE"] = 6] = "SAVE_THE_DATE";
    DataType_index[DataType_index["INSURANCE"] = 7] = "INSURANCE";
    DataType_index[DataType_index["AGING"] = 8] = "AGING";
    DataType_index[DataType_index["PHOTO"] = 9] = "PHOTO";
    DataType_index[DataType_index["ACCOUNT"] = 10] = "ACCOUNT";
    DataType_index[DataType_index["PROVIDER"] = 11] = "PROVIDER";
    DataType_index[DataType_index["OPERATORY"] = 12] = "OPERATORY";
    DataType_index[DataType_index["CLIENT_LOCATION"] = 13] = "CLIENT_LOCATION";
    DataType_index[DataType_index["RECALL"] = 14] = "RECALL";
    DataType_index[DataType_index["FRAMES_ORDER"] = 15] = "FRAMES_ORDER";
    DataType_index[DataType_index["CONTACTS_ORDER"] = 16] = "CONTACTS_ORDER";
    DataType_index[DataType_index["VACCINE_RECALL"] = 17] = "VACCINE_RECALL";
    DataType_index[DataType_index["CONTACT_INFO"] = 18] = "CONTACT_INFO";
    DataType_index[DataType_index["PET"] = 19] = "PET";
    DataType_index[DataType_index["PERSON_SERVICEABLE"] = 20] = "PERSON_SERVICEABLE";
    DataType_index[DataType_index["RECALL_TYPE"] = 21] = "RECALL_TYPE";
    DataType_index[DataType_index["MEDICAL_HISTORY"] = 22] = "MEDICAL_HISTORY";
    DataType_index[DataType_index["PROCEDURE_LOG"] = 23] = "PROCEDURE_LOG";
    DataType_index[DataType_index["APPOINTMENT_PROCEDURE"] = 24] = "APPOINTMENT_PROCEDURE";
    DataType_index[DataType_index["APPOINTMENT_PROVIDER"] = 25] = "APPOINTMENT_PROVIDER";
    DataType_index[DataType_index["PROCEDURE_CODE"] = 26] = "PROCEDURE_CODE";
    DataType_index[DataType_index["FEE_SCHEDULE"] = 27] = "FEE_SCHEDULE";
    DataType_index[DataType_index["FEE_SCHEDULE_FEE"] = 28] = "FEE_SCHEDULE_FEE";
    DataType_index[DataType_index["DOCUMENT"] = 29] = "DOCUMENT";
    DataType_index[DataType_index["MEDICAL_CONDITION"] = 30] = "MEDICAL_CONDITION";
    DataType_index[DataType_index["TEXT_NOTE"] = 31] = "TEXT_NOTE";
    DataType_index[DataType_index["PAYMENT"] = 32] = "PAYMENT";
    DataType_index[DataType_index["INSURANCE_PLAN"] = 33] = "INSURANCE_PLAN";
    DataType_index[DataType_index["INSURANCE_PAYER_DETAILS"] = 34] = "INSURANCE_PAYER_DETAILS";
    DataType_index[DataType_index["INSURANCE_DETAILS"] = 35] = "INSURANCE_DETAILS";
    DataType_index[DataType_index["SCHEDULE_AVAILABILITY"] = 36] = "SCHEDULE_AVAILABILITY";
    DataType_index[DataType_index["SCHEDULE"] = 37] = "SCHEDULE";
})(DataType_index || (DataType_index = {}));
